import React, { ReactNode } from 'react'
import { Element } from 'react-bulma-components'

export interface DayProps {
  /** Header left content (e.g. day number or day label). */
  label?: ReactNode
  /** Header right content (e.g. DayCellActions). */
  right?: ReactNode
  /** Main cell content. */
  children?: ReactNode
  /** When true, renders an empty placeholder cell (e.g. out-of-range in a calendar). */
  empty?: boolean
  /** Optional class for the td. */
  tdClassName?: string
  /** Optional style for the td. */
  tdStyle?: React.CSSProperties
}

const EmptyTd: React.FC<{ children?: ReactNode }> = ({ children }) => (
  <Element renderAs="td">
    <Element renderAs="span" textSize={7}>
      {children}
    </Element>
  </Element>
)

/**
 * Generic schedule/day cell: a table cell with optional header row (label + right) and content (children).
 * No calendar context: parents provide label, right, and children.
 */
export const Day: React.FC<DayProps> = ({
  label,
  right,
  children,
  empty = false,
  tdClassName = 'px-2',
  tdStyle,
}) => {
  if (empty) {
    return <EmptyTd />
  }

  return (
    <Element renderAs="td" className={tdClassName} style={tdStyle}>
      <Element display="flex" justifyContent="space-between" mb={2}>
        <Element>
          {label != null && (
            <Element textSize={6} textWeight="bold" renderAs="span" mr={1}>
              {label}
            </Element>
          )}
        </Element>
        <Element>{right}</Element>
      </Element>
      {children}
    </Element>
  )
}
